class SwaggerDetailsTabsEnum {
    static SUMMARY = 'summary';
    static EXAMPLES = 'examples';
    static PARAMETERS = 'parameters';
    static RELATED_GUIDES = 'related_guides';
}

export {SwaggerDetailsTabsEnum}